import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';

/* istanbul ignore next */
export default universal(
    universalImport({
        chunkName: () => 'ResetPasswordPage',
        path: () => path.join(__dirname, './ResetPasswordPage'),
        resolve: () => require.resolveWeak('./ResetPasswordPage'),
        load: () =>
            Promise.all([
                import(/* webpackChunkName: "ResetPasswordPage" */ './ResetPasswordPage'),
            ]).then((proms) => proms[0]),
    })
);
